import { render, staticRenderFns } from "./wrap.vue?vue&type=template&id=a05374f4&"
import script from "./wrap.vue?vue&type=script&lang=js&"
export * from "./wrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports